
import { Component, Input, forwardRef } from '@angular/core';

import { BaseFormWidgetComponent } from '../../../shared/base-form.component';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'radioset',
    template: `
<div [class]="'radioset' + (klass ? ' ' + klass : '') + (disabled ? ' disable' : '')" widget>
    <div class="list" [class.inline]="inline">
        <div class="btn-container"*ngFor="let btn of list; let i = index" >
            <radio-btn [klass]="name" [disabled]="disabled" [model]="model===i" [label]="btn" (modelChange)="update(i)"></radio-btn>
        </div>
    </div>
</div>`,
    styles: [`.inline>*{display:inline-block}`],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => RadiosetComponent),
        multi: true
    }]
})
export class RadiosetComponent extends BaseFormWidgetComponent<number> implements ControlValueAccessor {
    @Input() public list: string[] = [];
    @Input() public inline = false;

    public update(index: number) {
        this.model = index;
        this.modelChange.emit(index);
    }
}
